(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softspace-category-groups"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('softspace-product-reel')) {
    customElements.define('softspace-product-reel', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.ss-reel__track');
        const previousBelt = [...this.track.children].find(el => el.classList.contains('ss-reel__belt'));
        if (previousBelt) previousBelt.replaceWith(...previousBelt.children);
        [...this.track.children].filter(el => el.hasAttribute('data-reel-clone')).forEach(clone => clone.remove());
        this.slides = [...this.track.children].filter(el => el.matches('.ss-reel__card'));
        if (this.slides.length < 2) return;
        this.belt = document.createElement('div');
        this.belt.className = 'ss-reel__belt';
        this.belt.append(...this.slides);
        this.track.append(this.belt);
        this.track.classList.add('ss-reel__viewport');
        this.clones = this.slides.map(slide => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('data-reel-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a,button,[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
          this.belt.append(clone);
          return clone;
        });
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.visible = false;
        this.hovered = false;
        this.querySelector('.ss-reel__controls').hidden = false;
        const on = (target, event, callback) => target.addEventListener(event, callback, { signal });
        on(this.querySelector('[data-reel-prev]'), 'click', () => { this.clear(); this.move(-1); });
        on(this.querySelector('[data-reel-next]'), 'click', () => { this.clear(); this.move(1); });
        on(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.clear(); } });
        on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
        on(this, 'focusin', () => this.clear());
        on(this, 'focusout', () => queueMicrotask(() => this.schedule()));
        on(this.track, 'pointerdown', () => this.clear());
        on(this.track, 'wheel', event => { if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) this.clear(); });
        on(this.track, 'keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault(); this.clear();
          if (event.key === 'Home') this.scrollToCard(0);
          else if (event.key === 'End') this.scrollToCard(this.slides.length - 1);
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        });
        on(document, 'visibilitychange', () => this.schedule());
        on(this.motion, 'change', () => { this.paused = this.motion.matches; this.schedule(); });
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold:.25 });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => this.schedule());
        this.resizeObserver.observe(this.track);
      }
      clear() {
        if (!this.animation) return;
        const position = ((Number(this.animation.currentTime) || 0) * 12 / 1000) % this.cycle;
        this.animation.cancel();
        this.animation = null;
        this.belt.style.removeProperty('will-change');
        this.track.classList.remove('ss-reel__flowing');
        this.track.scrollTo({left:position, behavior:'instant'});
      }
      schedule() {
        this.clear();
        if (this.paused || !this.visible || this.hovered || document.hidden || this.contains(document.activeElement)) return;
        if (this.motion.matches) return;
        this.cycle = this.clones[0].getBoundingClientRect().left - this.slides[0].getBoundingClientRect().left;
        if (this.cycle < 2 || !this.belt.animate) return;
        const position = this.track.scrollLeft % this.cycle;
        this.track.scrollTo({left:0, behavior:'instant'});
        this.track.classList.add('ss-reel__flowing');
        this.belt.style.willChange = 'transform';
        this.animation = this.belt.animate([
          {transform:'translate3d(0,0,0)'},
          {transform:'translate3d(-' + this.cycle + 'px,0,0)'}
        ], {duration:this.cycle / 12 * 1000, iterations:Infinity, easing:'linear'});
        this.animation.currentTime = position / 12 * 1000;
      }
      scrollToCard(index) {
        const left = Math.min(this.track.scrollWidth - this.track.clientWidth, this.slides[index].offsetLeft - this.slides[0].offsetLeft);
        this.track.scrollTo({ left, behavior:this.motion.matches ? 'instant' : 'smooth' });
      }
      move(direction) {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max < 2) return;
        const origin = this.slides[0].offsetLeft;
        const current = this.slides.reduce((best, slide, i) =>
          Math.abs(slide.offsetLeft - origin - this.track.scrollLeft) < Math.abs(this.slides[best].offsetLeft - origin - this.track.scrollLeft) ? i : best, 0);
        if (direction > 0 && this.track.scrollLeft >= max - 8) this.scrollToCard(0);
        else if (direction < 0 && this.track.scrollLeft <= 8) this.scrollToCard(this.slides.length - 1);
        else this.scrollToCard(Math.max(0, Math.min(this.slides.length - 1, current + direction)));
      }
      disconnectedCallback() { this.clear(); this.observer?.disconnect(); this.resizeObserver?.disconnect(); this.abort?.abort(); this.abort = null; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
